<template>
  <table>
    <tr>
      <td :style="mainStyle">
        <br>
        <b v-if="name" :style="nameStyle">{{name}}, </b>{{jobTitle}}<br>
        <a v-if="email" :href="`mailto:${email}`" :style="linkStyle">{{email}}</a>
        <template v-if="extension || mobile"> <Separator :color="colors.black" character="•"/> </template>
        <template v-if="extension">0203 745 5{{ extension }}</template><template v-if="extension && mobile"> <Separator :color="colors.black" character="•"/> </template><template v-if="mobile">{{ mobile }}</template>
        <template v-if="extraInfo"><br><br><b :style="extraInfoStyle">{{ extraInfo }}</b></template>
        <template v-if="email || extension || mobile || extraInfo"><br><br></template>

        <div>
          <table>
            <tr>
              <td valign="middle" :style="footerLogoCellStyle">
                <email-safe-image url="https://fivium.co.uk/email-signatures/ecase-white.png" :width="140" :height="43" :email-app="emailApp" alt="eCase" :paddingRight="20" :paddingLeft="20"/>
              </td>
              <td valign="middle" :style="footerTextCellStyle">
                <span :style="nowrap">Fivium Ltd,</span> <span :style="nowrap">15 Adam Street</span>, London, <span :style="nowrap">WC2N 6AH</span>
                <Separator :color="colors.black" character="•"/>
                <a href="https://ww2.ecase.co.uk/?utm_source=signature&utm_medium=email&utm_campaign=signature_generic" target="_blank" :style="footerLinkStyle">ecase.co.uk</a>
                <Separator :color="colors.black" character="•"/>
                <span :style="nowrap">0800 3689 345</span>
                <br>
                Follow us on <a href="https://linkedin.com/company/fivium/" target="_blank" :style="footerLinkStyle">LinkedIn</a>
                <Separator :color="colors.black" character="•"/>
                Twitter <a href="https://twitter.com/eCase4gov" target="_blank" :style="footerLinkStyle">@eCase4gov</a>
                <Separator :color="colors.black" character="•"/>
                Facebook <a href="https://facebook.com/fivium" target="_blank" :style="footerLinkStyle">@Fivium</a>
              </td>
            </tr>
            <tr v-if="hasCta">
              <td colspan="2" :style="footerCTAStyle">
                <span :style="footerCTATextStyle" v-html="ctaText"></span>
                <a :href="ctaLinkUrl" :style="footerCTALinkStyle" target="_blank">{{ ctaLinkText }}</a>
              </td>
            </tr>
          </table>
        </div>

      </td>
    </tr>
  </table>
</template>

<script>
import EmailSafeImage from "@/components/EmailSafeImage";
import Separator from "@/components/Separator";

export default {
  name: "SignatureTemplateEcase",
  components: { EmailSafeImage, Separator },
  props: [
    'name',
    'jobTitle',
    'email',
    'extension',
    'mobile',
    'extraInfo',
    'emailApp',
    'ctaText',
    'ctaLinkUrl',
    'ctaLinkText',
    'showCta'
  ],
  data() {
    const colors = {
      purple: '#662d91',
      lightBlue: '#f5f8fa',
      midBlue: '#e3e8ec',
      white: '#ffffff',
      black: '#666',
      linkBlue: '#15c'
    };

    const fontFamily = 'Arial, Helvetica, sans-serif';
    const fontSize = '13.333px';

    return {
      colors: colors,
      fontFamily: fontFamily,
      fontSize: fontSize,
      nameStyle: {
        color: colors.black,
        fontWeight: 'bold',
        fontSize: fontSize,
        fontFamily: fontFamily
      },
      extraInfoStyle: {
        color: colors.black,
        fontWeight: 'bold',
        fontSize: fontSize,
        fontFamily: fontFamily
      },
      linkStyle: { color: colors.linkBlue },
      mainStyle: {
        color: colors.black,
        fontSize: fontSize,
        fontFamily: fontFamily
      },
      footerLinkStyle: {
        color: colors.linkBlue,
        textDecoration: 'underline',
        whiteSpace: 'nowrap'
      },
      footerCTAStyle: {
        borderRadius: '0 0 5px 5px',
        backgroundColor: colors.midBlue,
        color: colors.black,
        padding: '15px 20px',
        textAlign: 'center'
      },
      footerCTATextStyle: {
        fontFamily: fontFamily,
        fontSize: fontSize,
        color: colors.black,
        fontWeight: 'bold'
      },
      footerCTALinkStyle: {
        textDecoration: 'underline',
        color: colors.linkBlue,
        fontWeight: 'bold',
        fontFamily: fontFamily,
        fontSize: fontSize
      },
      nowrap: {
        whiteSpace: 'nowrap'
      }
    }
  },
  computed: {
    footerLogoCellStyle() {
      return {
        background: this.colors.purple,
        borderRadius: `5px 0 0 ${this.hasCta ? 0 : 5}px`}
    },
    footerTextCellStyle() {
      return {
        padding: '20px',
        borderRadius: '0 5px 5px 0',
        background: this.colors.lightBlue,
        color: this.colors.black,
        fontSize: this.fontSize,
        fontFamily: this.fontFamily
      }
    },
    hasCta() {
      return (this.ctaText || (this.ctaLinkText && this.ctaLinkUrl)) && this.showCta
    }
  }
}
</script>

<style scoped>

</style>
